module.exports = __webpack_public_path__ + "assets/month-icon.e2c13085.svg";